import { Location } from 'history'
import { ICartDictionary, IConfig, IOrder, IProduct } from '@engyalo/storefront-types/lib/plugins/model'

export enum ActionScreen {
  PRODUCT_LIST = 'Product List',
  PRODUCT_DETAIL = 'Product Detail',
  SEARCH_RESULT_LIST = 'Search Result List',
  CART = 'Cart',
}

export const getActionScreen = ({ pathname, search }: Location): ActionScreen => {
  if (pathname.includes('cart')) {
    return ActionScreen.CART
  }

  if (pathname.includes('product')) {
    return ActionScreen.PRODUCT_DETAIL
  }

  if (search) {
    return ActionScreen.SEARCH_RESULT_LIST
  }

  return ActionScreen.PRODUCT_LIST
}

export const getOrderNote = ({ enabledOrderNote }: IConfig, { orderNote }: IOrder): string => {
  if (!enabledOrderNote) {
    return 'Not Supported'
  }

  return orderNote
}

export const getFlatProductValues = (cart: ICartDictionary) => (key: keyof IProduct): string[] =>
  Object.values(cart).flatMap((product: IProduct) =>
    Array.from({ length: product?.quantity ?? 0 }).map(() => product[key] ?? '')
  )


export const getProductSummaries = (cartDictionary: ICartDictionary): any => {
    const summaryProducts: any = [];
    Object.keys(cartDictionary).forEach((key, index) => { 
       const product: IProduct = cartDictionary[key];
       const price: number = product.price == null ? 0 : product.price;
       const quantity: number = product.quantity == null ? 0 : product.quantity;
       const amount: number = price * quantity;
       summaryProducts.push({'id': product.id ,'cartId': product.cartId, 'price': price, 'quantity': quantity, 'amount': amount });
    });
    return summaryProducts;
}
  
export const getCustomerCode = (metadata: string | null): string => {
  const NOT_APPLICABLE = 'Not Applicable'

  if (!metadata) {
    return NOT_APPLICABLE
  }

  try {
    const parsedMetadata = JSON.parse(metadata)

    return parsedMetadata?.customerCode || NOT_APPLICABLE
  } catch (error) {
    return NOT_APPLICABLE
  }
}
